import { useMutation, useQuery } from "@apollo/client";
import React from "react";
import { BreadCrumb, BreadCrumbProp } from "../../../../components/light/Breadcrumb";
import { Content } from "../../../../components/light/Content";
import { SectionBlock } from "../../../../components/light/SectionBlock";
import { Loading } from "../../../../components/Loading";
import { Graphql } from "../../../../graphql/_graphql";
import moment from "moment";
import { Link } from "react-router-dom";
import { Table } from "src/components/layout/tables/Table";

const BreadCrumbItems: BreadCrumbProp[] = [
  {
    text: "Applications",
    to: "#",
  },
  {
    text: "Products",
    to: "#",
  },
  {
    text: "Feed",
    to: "/feed",
  },
];

export function FeedListScreen() {
  const { data, loading } = useQuery(Graphql.Query.QUERY_FEED_LIST, {
    fetchPolicy: "no-cache",
    variables: {
      offset: 0,
      limit: 10000,
    },
  });
  const [merchantTogglePublishFeed] = useMutation(Graphql.Mutation.MUTATION_TOGGLE_PUBLISH_FEED, {
    refetchQueries: ["merchantFeedList"],
  });

  if (data === undefined || loading) {
    return (
      <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
        <div className="row">
          <div className="col-md-6">
            <SectionBlock title="Feed" transparent={true}>
              <Loading />
            </SectionBlock>
          </div>
        </div>
      </Content>
    );
  }

  return (
    <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
      <div className="row">
        <div className="col-md-7">
          <SectionBlock title="Feed Product" transparent={true}>
            <div className="row">
              <div className="col-md-6">
                <small>Note: Click on status column to change status</small>
              </div>
              <div className="col-md-6 text-right">
                <Link to="/feed/create" className="btn btn-secondary btn-sm">
                  Create new feed
                </Link>
              </div>
            </div>
            <br />
            <br />
            <Table seperator stripe>
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Description</th>
                  <th>Created Date</th>
                  <th className="text-center">Status</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {data.merchantFeedList.map((x: any, i: number) => {
                  return (
                    <tr key={i}>
                      <td style={{ width: 170 }}>
                        <div
                          className="cell-image-list"
                          style={{ display: "inline-block", position: "relative", whiteSpace: "nowrap" }}
                        >
                          {x.items.map((y: any, j: number) => {
                            return (
                              j <= 2 && (
                                <div
                                  className="cell-img"
                                  style={{
                                    backgroundImage: `url(${y.thumb_small})`,
                                    width: 30,
                                    height: 30,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center center",
                                    borderRadius: 2,
                                    verticalAlign: "middle",
                                    transform: "scale(1)",
                                    position: "relative",
                                    display: "inline-block",
                                    cursor: "pointer",
                                    boxShadow: "0px 0px 0px 2px #fff, 1px 1px 5px rgb(0 0 0 / 80%)",
                                    transition: "all 0.1s ease",
                                    zIndex: 5 - j,
                                  }}
                                  key={j}
                                ></div>
                              )
                            );
                          })}
                          {x.items.length > 3 && <div className="cell-img-more">+ {x.items.length - 3} more</div>}
                        </div>
                      </td>
                      <td style={{ width: 300 }}>
                        <small className="text-muted">{x.text}</small>
                      </td>
                      <td>
                        <small className="text-muted">{moment(new Date(x.created_at)).format("YYYY-MM-DD")}</small>
                      </td>
                      <td className="text-center" style={{ width: 120 }}>
                        <Link
                          to="#"
                          className={`text-${x.published === "T" ? "success" : "danger"}`}
                          onClick={() => {
                            merchantTogglePublishFeed({
                              variables: { feedId: Number(x.id) },
                            });
                          }}
                        >
                          {x.published === "T" ? (
                            <small>&#x2713; Published</small>
                          ) : (
                            <small>&#x2718; Unpublished</small>
                          )}
                        </Link>
                      </td>
                      <td className="text-center">
                        <Link to={`/feed/edit/${x.id}`} className="btn btn-sm btn-primary">
                          Edit
                        </Link>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </SectionBlock>
        </div>
      </div>
    </Content>
  );
}
